import { createAsyncThunk } from "@reduxjs/toolkit";
import * as api from "../../services/auth.service";
import { IUpdateUser } from "../../models/auth.model";

// Async thunks
export const loginUser = createAsyncThunk(
  "auth/login",
  async (payload: { email: string; password: string }, { rejectWithValue }) => {
    try {
      const response = await api.login(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || "Login failed");
    }
  }
);

export const verifyCode = createAsyncThunk(
  "auth/verifyCode",
  async (
    payload: { email: string; verification_code: string },
    { rejectWithValue }
  ) => {
    try {
      const response = await api.verifyCode(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Verify code failed"
      );
    }
  }
);

export const forgotPassword = createAsyncThunk(
  "auth/forgotPassword",
  async (payload: { email: string }, { rejectWithValue }) => {
    try {
      const response = await api.forgotPassword(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Forgot password failed"
      );
    }
  }
);

export const resetPassword = createAsyncThunk(
  "auth/resetPassword",
  async (payload: { password: string; token: string }, { rejectWithValue }) => {
    try {
      const response = await api.resetPassword(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Reset password failed"
      );
    }
  }
);

export const getUserInfor = createAsyncThunk(
  "auth/getUserInfor",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.getUserInfor();
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Get user information failed"
      );
    }
  }
);

export const updateUserInfor = createAsyncThunk(
  "auth/updateUserInfor",
  async (payload: IUpdateUser, { rejectWithValue }) => {
    try {
      const response = await api.updateUserInfor(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Update user information failed"
      );
    }
  }
);

export const resendVerificationCode = createAsyncThunk(
  "auth/resendVerificationCode",
  async (payload: { email: string }, { rejectWithValue }) => {
    try {
      const response = await api.resendVerificationCode(payload.email);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Resend verification code failed"
      );
    }
  }
);

export const switchCompany = createAsyncThunk(
  "company/selectCompany",
  async (companyId: string, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.switchCompany(companyId);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Select company failed"
      );
    }
  }
);
